import {Route, useNavigation} from '@react-navigation/native';
import View from './view';
import {useDispatch, useSelector} from 'react-redux';
import {pollDetailsSelector} from '../../../redux/selectors/polls';
import React, {useCallback, useEffect, useState} from 'react';
import {completePoll, getPollDetails} from '../../../redux/actions/polls/details';
import {RegisterPollAnswerRequestPayload} from '../../../shared/models/api';
import {getFormErrors, pollAnswersParser, pollFormGroupTransform} from '../helpers';
import {Screens} from '../../../shared/routing';
import {useModal} from '../../../shared/components/modal';
import {SurveyCongrats} from '../components/surveyCongratsModal';
import {destroy, initialize, SubmissionError} from 'redux-form';
import {Forms} from '../../../shared/models/forms';
import {addNotification} from '../../../redux/actions/snackbar';
import {SnackbarNotificationType} from '../../../shared/components/snackbar/model';

export const PollsTypeSurveyFormScreen = ({route}: {route: Route<string>}) => {
  const poll = useSelector(pollDetailsSelector());
  const nav = useNavigation();
  // @ts-ignore
  const pollId = route.params?.pollId;
  const modals = useModal();
  const [isSurveyCompleteNow, setIsSurveyCompleteNow] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(destroy(Forms.pollForm));
    if (poll) {
      nav.setOptions({title: isSurveyCompleteNow && poll.isPassed ? 'Завершение опроса' : poll.name});
      if (poll.isPassed) {
        dispatch(initialize(Forms.pollForm, pollFormGroupTransform(poll.questions)));
      }
    }
  }, [poll, pollId, isSurveyCompleteNow]);

  const showCongrats = useCallback(() => {
    modals.show({
      render(modal, methods) {
        const back = () => {
          if (nav.canGoBack()) {
            nav.goBack();
          } else {
            nav.navigate(Screens.Polls);
          }
        };
        const hideModal = () => {
          methods.remove(modal.id);
        };

        return (
          <SurveyCongrats
            onClose={() => {
              hideModal();
              back();
            }}
          />
        );
      },
    });
  }, [poll, modals]);

  return View({
    poll,
    isSurveyCompleteNow,
    onBack: () => {
      nav.navigate(Screens.PollsTypeSurvey);
    },
    onSubmit: async (data) => {
      if (!poll) {
        return;
      }
      const answers = pollAnswersParser(data);
      const payload: RegisterPollAnswerRequestPayload = {
        pollId: +pollId,
        answers,
      };
      const submissionError = getFormErrors(poll, data);
      if (submissionError) {
        dispatch(
          addNotification({
            message: 'Пожалуйста, ответьте на все вопросы',
            type: SnackbarNotificationType.Error,
          }),
        );
        throw new SubmissionError(submissionError);
      }
      await completePoll(payload);
      await dispatch(getPollDetails(pollId));
      setIsSurveyCompleteNow(true);
      showCongrats();
    },
  });
};
